export default "__VITE_ASSET__Bcj4lsWM__"